import { signInWithPopup, signOut, /* GoogleAuthProvider */ } from 'firebase/auth';
import { auth, googleProvider } from '../../firebaseConfig';
import { socialSignIn } from '../../services/authService';

export const signInWithGoogle = async (shouldSignOut = true) => {
  if (shouldSignOut) {
    await signOut(auth);
  }

  // Solicita scopes adicionales si es necesario
  googleProvider.setCustomParameters({
    prompt: 'select_account',
  });

  // Scope de Calendar (comentado porque no se usará)
  // googleProvider.addScope('https://www.googleapis.com/auth/calendar.readonly');

  try {
    const result = await signInWithPopup(auth, googleProvider);

    // Código relacionado con GoogleAuthProvider (comentado porque no se usa accessToken)
    /*
    const credential = GoogleAuthProvider.credentialFromResult(result);

    if (!credential) {
      console.error('No se pudo obtener la credencial de Google.');
      return null;
    }

    const accessToken = credential.accessToken;
    */

    const idToken = await result.user.getIdToken();

    const user = result.user;
    const email = user.email;
    const displayName = user.displayName;

    let firstName = '';
    let lastName = '';

    if (displayName) {
      const nameParts = displayName.split(' ');
      firstName = nameParts[0];
      lastName = nameParts.slice(1).join(' ');
    }

    // Guarda el access token (comentado porque no se usa)
    // localStorage.setItem('google_access_token', accessToken!);

    const response = await socialSignIn(email!, idToken);

    if (response) {
      return {
        response,
        idToken,
        // accessToken, // Comentado porque no se usa
        userData: {
          firstName,
          lastName,
          email,
          phoneNumber: user.phoneNumber,
        },
      };
    } else {
      console.error('No se recibió una respuesta válida del servidor.');
      return null;
    }
  } catch (error) {
    console.error('Error de autenticación con Google:', error);
    return null;
  }
};
